import { BaseConfirmationDialog } from '@plato/ui-legacy/components/dialog/confirmation-dialog';
import { DialogStateManager, useDialog } from '@plato/ui-legacy/components/dialog/dialog-provider';
import { InfoIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { CrmNoteDTO } from '../../../server/dto/crm-note-dto.ts';

export type NotePinConfirmationDialogProps = {
    note: CrmNoteDTO;
    onConfirm: () => void;
};

export const NotePinConfirmationDialog = DialogStateManager.create<NotePinConfirmationDialogProps>(
    ({ onConfirm }) => {
        const { remove } = useDialog();
        const { t } = useTranslation('notes');

        return (
            <BaseConfirmationDialog
                focus="destroy"
                icon={InfoIcon}
                title={t('notes__pin_confirmation_title')}
                description={t('notes__pin_confirmation_description')}
            >
                <BaseConfirmationDialog.Actions>
                    <BaseConfirmationDialog.RejectButton onClick={remove}>
                        {t('notes__pin_confirmation_cancel')}
                    </BaseConfirmationDialog.RejectButton>
                    <BaseConfirmationDialog.AcceptButton
                        onClick={() => {
                            onConfirm();
                            remove();
                        }}
                    >
                        {t('notes__pin_confirmation_confirm')}
                    </BaseConfirmationDialog.AcceptButton>
                </BaseConfirmationDialog.Actions>
            </BaseConfirmationDialog>
        );
    },
);
